<template>
  <div class="costContainer h-100">
    <fullscreen ref="fullscreen" :fullscreen.sync="isFullScreen">
      <b-row class="m-0">
        <b-col cols="10">
          <h2>
            Ethanol/ RBOB : Reversion to the mean adds $0.30/gal to the crush
            ($10/t in DDGs adds $0.03/gal to the crush)
          </h2>
        </b-col>
        <b-col cols="2" class="text-right">
          <downloadChart :commitName="'Ethanol RCB'"/>
        </b-col>
      </b-row>
      <b-row class="m-0 chartTabPanel autoCursor">
        <b-col ref="capture">
          <Plotly
            :data="data"
            :xAxisType="xAxisType"
            :yAxisType="yAxisType"
            :title="chartTitle"
            :width="chartWidth"
            :layout="layout"
            :display-mode-bar="false"
          />
        </b-col>

        <div class="sourceTabWrapper">
          <h6 class="sourceTab">
            <b>Source: </b>Company Data (as of June 2019)
          </h6>
        </div>
      </b-row>
    </fullscreen>
  </div>
</template>

<script>
//------------Import Charts----------
import { mapGetters, mapActions } from "vuex";
import { Plotly } from "vue-plotly";
import downloadChart from "@/components/DownloadChart.vue";
import fullscreen from "vue-fullscreen";
import Vue from "vue";
Vue.use(fullscreen);
import "bootstrap-slider/dist/css/bootstrap-slider.css";
//-------------
export default {
  name: "Ethanol_RBOB",
  components: {
    Plotly,
    downloadChart,
  },
  props: {
    xField: {
      default: "xField",
    },
    yField: {
      default: "yField",
    },
    tickFormat: { default: ",.0%" },
    tickFormatX: { default: "" },
    tickFormatYaxis2: { default: "" },
    yAxisTitle: { default: "" },
    ynticks: { default: 4 },
    //isFullScreen: {default: false},
    chartBarMode: { default: "" },
  },
  computed: {
    ...mapGetters({
      ethanolRbob: "ethanolRbob",
      isFullScreen: "isFullScreen",
    }),
    chartData() {
      return this.ethanolRbob.map(function(i) {
        return {
          yField: parseFloat(parseFloat(i.rbob).toFixed(2)),
          xField: i.date,
        };
      });
    },
  },
  data() {
    return {
      chartTitle:
        "Ethanol/ RBOB : Reversion to the mean adds $0.30/gal to the crush ($10/t in DDGs adds $0.03/gal to the crush)",
      color: "#8EA4CE",
      name: "Ethanol/ RBOB",
      yAxisType: "linear",
      xAxisType: "date",
      chartWidth: 1250,
      fullscreen: false,
      chartData1: null,
      margin: {
        l: 80,
        r: 80,
        b: 0,
        t: 0,
        pad: 0,
      },
      data: [],
      loader: "bars",
      layout: {
        title: "",
        minWidth: this.chartWidth,
        height: 350,
        barmode: this.chartBarMode,
        xaxis: {
          autorange: true,
          nticks: 12,
          rangeslider: {
            range: [],
            visible: false,
          },

          showgrid: false,
          showline: true,
          zeroline: true,
          linecolor: "#636363",
          anchor: "y",
          ticklen: 5,
        },
        yaxis: {
          autorange: true,
          nticks: 9,
          type: "linear",
          showgrid: false,
          showline: true,
          linecolor: "#636363",
          anchor: "x",
          zeroline: false,
          ticklen: 9,
          tickformat: this.tickFormat,
          title: {
            text: this.yAxisTitle,
            standoff: 40,
          },
        },
        yaxis2: {
          autorange: true,
          type: "linear",
          showgrid: false,
          showline: true,
          linecolor: "#636363",
          anchor: "x",
          zeroline: false,
          ticklen: 5,
          overlaying: "y",
          side: "right",
          tickformat: this.tickFormatYaxis2,
        },
        showLegend: true,
        legend: {
          x: 0.35,
          y: -0.3,
          orientation: "h",
        },
        traceorder: "normal",
        font: {
          family: "sans-serif",
          size: 12,
          color: "#000",
        },
        bgcolor: "#2E2EE2",
        bordercolor: "silver",
        borderwidth: 2,
      },
      config: { responsive: true },
    };
  },
  created() {
    this.setDownloadInfo({
      fileName: "Ethanol",
      downloadData: this.$refs.capture,
    });
    window.addEventListener("resize", this.windowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },
  methods: {
    ...mapActions([
      "setDownloadInfo",
      "getChartDataById",
      "currentVersionUpdateHandler",
    ]),
    windowResize(e) {
      this.chartWidth = this.$refs.capture.clientWidth - 50;
    },
    unpack(rows, key) {
      return rows.map(function(row) {
        return row[key];
      });
    },
    async getIframeData() {
      if (window.location.href.includes("auth_token=")) {
        let data = await this.getChartDataById({
          id: 83,
          chartName: "Ethanol RCB",
          navigate: false,
        });
        let payLoadObj = {
          table_pk: data.drop_down_values.current_version.table_pk,
          chart_id: data.drop_down_values.current_version.chart_id,
          chartName: "Ethanol RCB",
        };
        let version = {
          version_data: payLoadObj,
          versionToggleValue: false,
        };
        // // console.log("versionnnnnnn", version);
        this.currentVersionUpdateHandler(version);
      }
    },
  },
  mounted() {
    // api call for iframe
    if (window.location.href.includes("auth_token=")) {
      this.getIframeData();
    }
    let x = this.unpack(this.chartData, "xField");
    let y = this.unpack(this.chartData, "yField");
    this.data.push({
      type: "scatter",
      mode: "lines",
      name: this.name,
      x: x,
      y: y,
      line: {
        color: this.color,
        shape: "spline",
        smoothing: 1.3,
      },
    });
    this.setDownloadInfo({
      fileName: "Ethanol",
      downloadData: this.$refs.capture,
    });
  },
};
</script>

<style lang="scss">
/*--------Graph Title--------------*/
.gtitle {
  text-align: center;
  font-weight: bold !important;
  color: #58595b;
  fill: #58595b !important;
  font-size: 1.5vw !important;
  position: relative;
  display: inline-block;
  padding: 0;
  margin: 0;
  margin-bottom: 1em;
}

/*--------Chart Settings-------------*/
.costContainer {
  .svgChart {
    position: relative;
    width: 100%;
    height: 100%;
  }
}

/*--------Source Tab-------------*/
.sourceTabWrapper {
  .sourceTab {
    font-size: 11px;
    padding: 0px 5px 0px 5px;
  }

  position: absolute;
  display: inline-block;
  right: 0;
  bottom: 1px;
  border: 1px solid silver;
  z-index: 50;
}
</style>
